import React from 'react';
import Form from '../../../components/common/Form';

class CustomFB extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            pages: this.props.pages,
            data: {
                email: "",
                password: ""
            },
            errors: {}
        };

    }

    componentDidUpdate() {
        if (this.state.pages !== this.props.pages) {
            this.setState({
                pages: this.props.pages
            })
        }
    }

    render() {
        let {
            selectedSource,
            checkPagesAndChannels,
            checked_send_all,
            checked_channels,
            facebook_platform_enabled
        } = this.props;

        let pages = this.state.pages
        // console.log('this.state.pages 1: ', pages)

        //console.log("pagespagespagespagespages", pages);
        // console.log("checked_channels", checked_channels);

        // console.log("checked_send_all", checked_send_all);
        let pages_mod = [];
        pages.forEach(function (page, i) {
            //   console.log('currentPage: ', page);

            // console.log("page", page);
            if (page.feed_id && selectedSource.toString() === page.feed_id.toString() && page.page_connected === "Connected") {
                //console.log('first if')
                //console.log("page.feed_id", page.feed_id);
                //console.log("page.page_connected", page.page_connected);
                pages_mod = pages;
            } else
                //(page.source_id && selectedSource.toString() === page.project_id.toString() && page.connected)
            {
                // console.log('second if')
                // console.log("page.source_id", page.source_id);
                // console.log("page.connected", page.connected);
                // console.log("iiiii iiiii iiiiii", i);
                pages_mod = pages;
                pages_mod[i].feed_id = page.project_id;
                pages_mod[i].fb_page_id = page.page_id;
                pages_mod[i].fb_page = page.page;
                pages_mod[i].page_connected = page.connected ? "Connected" : "Not Connected";

            }

        });

        // console.log("pages_mod", pages_mod);
        // console.log("facebook_platform_enabled", facebook_platform_enabled);
        pages = pages_mod;

        //  console.log('facebook_platform_enabled: ', facebook_platform_enabled)
        //  console.log('this.state.pages 2: ', pages)
        let connectedPagesNumber = 0;

        pages.map(page =>
            page.feed_id && selectedSource.toString() === page.feed_id.toString() && page.page_connected === "Connected" ?
                connectedPagesNumber++ : '')

        //console.log('connectedPagesNumber: ', connectedPagesNumber)

        return (
            <div className="section m-lg-b">
                <div className="section-content m-sm-b">
                    {
                        facebook_platform_enabled && pages.length && connectedPagesNumber !== 0 ?

                            pages.map(page =>
                                page.feed_id && selectedSource.toString() === page.feed_id.toString() && page.page_connected === "Connected" &&

                                <label key={page.fb_page_id} className="checkbox">
                                    {page.fb_page}
                                    <input
                                        onChange={checkPagesAndChannels}
                                        title="check"
                                        id={page.fb_page_id}
                                        type="checkbox"
                                        disabled={checked_send_all}
                                        name={page.fb_page}
                                        checked={checked_send_all ? true :
                                            (checked_channels.facebook.length > 0 && checked_channels.facebook.filter(el => {
                                                return (el.page.toString() === page.fb_page_id.toString())
                                            })[0].checked)}/>
                                    <span className="checkmark"></span>


                                </label>
                            )
                            :
                            <span className="text-light-grey">No Facebook pages connected to this workspace.</span>
                    }

                </div>

            </div>
        )
    }
}

export default CustomFB